/**
 * The Logs API parameter for a Log Explorer filter: `severity` → `severities`,
 * `service` → `services`. The log analyzer agent's `LOG_FILTERS` uses the same
 * names, so a filter reaches both without translation.
 */
export const toLogFilterParam = (filterLabel: string): string =>
  filterLabel === "severity" ? "severities" : `${filterLabel}s`;
